import { STACKS_COLUMN_CONFIG, STACKS_COLUMN_ID } from "./constants";

export const getLabel = (item: STACKS_COLUMN_ID) => {
  const title = STACKS_COLUMN_CONFIG[item]?.title;
  return title || "";
};
